import { render, staticRenderFns } from "./GiveInput.vue?vue&type=template&id=45fa56f2&scoped=true&"
import script from "./GiveInput.vue?vue&type=script&lang=js&"
export * from "./GiveInput.vue?vue&type=script&lang=js&"
import style0 from "./GiveInput.vue?vue&type=style&index=0&id=45fa56f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa56f2",
  null
  
)

export default component.exports